import {
  GET_FINAL,
  FINAL_LOADING,
  SET_FINAL_ITEMS_PER_PAGE,
  CHANGE_CURRENT_FINAL_PAGE,
  SEARCH_FINAL,
  FILTER_FINAL_FUNCTIONS,
  FILTER_FINAL_ROLES,
  FILTER_FINAL_STATUS,
  FILTER_FINAL_RECRUITER,
  FILTER_FINAL_POSITION_FILLED,
  FILTER_FINAL_DATE,
  SET_FINAL_PRICING_HISTORY,
  FILTER_FINAL_NO_DAYS,
  FILTER_FINAL_FLEXIBEES_SELECTED,
  FILTER_FINAL_CLIENT_SELECTED,
  SELECTION_CONFIRMATION_DETAILS,
} from "../actions/finalSelectionAction";

const initialState = {
  FinalList: [],
  FinalPricingHistory: [],
  FinalSearchText: "",
  FinalAppliedFunctionFilter: [],
  FinalAppliedRolesFilter: [],
  FinalAppliedStatusFilter: [],
  FinalAppliedRecruiterFilter: [],
  FinalAppliedPositionFilledFilter: [],
  FinalAppliedNumberOfDaysFilter: [],
  finalAppliedFlexibeesSelectedFilter: [],
  finalAppliedClientSelectedFilter: [],

  FinalAppliedDateFilter: [],
  FinalTotalResults: null,
  FinalCurrentPage: 1,
  FinalResultsPerPage: 10,
  FinalTotalPages: null,
  FinalPageIds: [],
  FinalFunctionFilter: [],
  FinalRolesFilter: [],
  FinalRecruiterFilter: [],
  FinalPositionFilledFilter: [],
  FinalNumberOfDaysFilter: [],
  finalFlexibeesSelectedFilter: [],
  finalClientSelectedFilter: [],
  fetchingData: true,
  selectionDetails:[]
};

const finalSelectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FINAL: {
      return {
        ...state,
        FinalList: action.payload.result.results,
        FinalTotalResults: action.payload.result.total_results,
        FinalTotalPages: action.payload.result.total_pages,
        FinalPageIds: action.payload.result.page_ids,
        FinalFunctionFilter: action.payload.filter_data.functions,
        FinalRolesFilter: action.payload.filter_data.roles,
        FinalRecruiterFilter: action.payload.filter_data.recruiters,
        FinalPositionFilledFilter: action.payload.filter_data.no_of_positions,
        FinalNumberOfDaysFilter: action.payload.filter_data.no_of_days,
        finalFlexibeesSelectedFilter:
          action.payload.filter_data.flexibees_selected,
        finalClientSelectedFilter: action.payload.filter_data.client_selected,
        fetchingData: false,
      };
    }
    case SET_FINAL_PRICING_HISTORY: {
      return {
        ...state,
        FinalPricingHistory: action.payload,
      };
    }
    case CHANGE_CURRENT_FINAL_PAGE: {
      return {
        ...state,
        FinalCurrentPage: action.payload,
      };
    }
    case SET_FINAL_ITEMS_PER_PAGE: {
      return {
        ...state,
        FinalResultsPerPage: action.payload,
      };
    }
    case SEARCH_FINAL: {
      return {
        ...state,
        FinalSearchText: action.payload,
      };
    }
    case FILTER_FINAL_FUNCTIONS: {
      return {
        ...state,
        FinalAppliedFunctionFilter: action.payload,
      };
    }
    case FILTER_FINAL_ROLES: {
      return {
        ...state,
        FinalAppliedRolesFilter: action.payload,
      };
    }
    case FILTER_FINAL_STATUS: {
      return {
        ...state,
        FinalAppliedStatusFilter: action.payload,
      };
    }
    case FILTER_FINAL_RECRUITER: {
      return {
        ...state,
        FinalAppliedRecruiterFilter: action.payload,
      };
    }
    case FILTER_FINAL_POSITION_FILLED: {
      return {
        ...state,
        FinalAppliedPositionFilledFilter: action.payload,
      };
    }
    case FILTER_FINAL_DATE: {
      return {
        ...state,
        FinalAppliedDateFilter: action.payload,
      };
    }
    case FILTER_FINAL_FLEXIBEES_SELECTED: {
      return {
        ...state,
        finalAppliedFlexibeesSelectedFilter: action.payload,
      };
    }
    case FILTER_FINAL_CLIENT_SELECTED: {
      return {
        ...state,
        finalAppliedClientSelectedFilter: action.payload,
      };
    }
    case FILTER_FINAL_NO_DAYS: {
      return {
        ...state,
        FinalAppliedNumberOfDaysFilter: action.payload,
      };
    }
    case FINAL_LOADING: {
      return {
        ...state,
        fetchingData: true,
      };
    }
     case SELECTION_CONFIRMATION_DETAILS: {
      return {
        ...state,
        selectionDetails: action.payload,
      };
    }
    default:
      return state;
  }
};

export default finalSelectionReducer;
